import { Component, Input } from '@angular/core';
import System from 'framework/System';

@Component({
	selector: 'app-components-specialist-actioncomponents-information-legacy',
	templateUrl: './InformationLegacy.component.html'
})
export class InformationLegacyComponent {
  public customer: Boo.Objects.Customer;
  public taskDetails: Boo.Objects.ActionDetail;

  public activate(params: any): JQueryPromise<void> {
      this.customer = params.customer;
      this.taskDetails = params.taskDetails;
      return System.emptyPromise();
  }
}